// extracted by mini-css-extract-plugin
module.exports = {"content":"ReadMore_content__DlHzw"};